'use client'

import { isBrowser } from '@/utils/env'
import { Button } from '../button'

export type FooterCookiePreferencesProps = {
  children: React.ReactNode
}

const FooterCookiePreferences = ({
  children
}: FooterCookiePreferencesProps) => {
  const showCookiePreferences = () => {
    if (!isBrowser) return

    window?.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
  }

  return (
    <Button
      sectionName={`footer_cookie_preferences`}
      onClick={() => showCookiePreferences()}
      appearance="text"
      color="gray"
      size="xs"
      weight="medium"
    >
      {children}
    </Button>
  )
}

export default FooterCookiePreferences
